import { z } from 'zod';

export const actionTemplateGovmapGroupDatabaseRawSchema = z.object({
  action_template_id: z.string(),
  govmap_group_id: z.string(),
});

export const actionTemplateGovmapGroupDatabaseSchema =
  actionTemplateGovmapGroupDatabaseRawSchema.transform((data) => ({
    actionTemplateId: data.action_template_id,
    govmapGroupId: data.govmap_group_id,
  }));

export type ActionTemplateGovmapGroupEntity = z.infer<
  typeof actionTemplateGovmapGroupDatabaseSchema
>;
